import React, { createContext, useState, useEffect, useRef } from 'react';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const isInitialized = useRef(false);
  const skipUrlUpdate = useRef(true);
  const [language, setLanguage] = useState(() => {
    return 'en';
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    let initialLang;

    if (langParam && ['en', 'ru'].includes(langParam)) {
      initialLang = langParam;
      localStorage.setItem('language', langParam);
    } else {
      const savedLanguage = localStorage.getItem('language');
      if (savedLanguage) {
        initialLang = savedLanguage;
      } else {
        const browserLang = navigator.language || navigator.userLanguage || '';
        const isRussian = /^ru\b/.test(browserLang) || browserLang.toLowerCase().includes('ru');
        initialLang = isRussian ? 'ru' : 'en';
      }
    }

    setLanguage(initialLang);

    isInitialized.current = true;

    setTimeout(() => {
      skipUrlUpdate.current = false;
    }, 0);
  }, []);

  useEffect(() => {
    if (!skipUrlUpdate.current) {
      const url = new URL(window.location);
      url.searchParams.set('lang', language);
      window.history.replaceState({}, '', url);
    }

    document.documentElement.lang = language;

    document.title = language === 'ru' ? 'Александр Федотов - Разработчик ПО' : 'Alexander Fedotov - Software Developer';

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }

    metaDescription.content = language === 'ru'
      ? 'Персональный сайт Александра Федотова - разработчика программного обеспечения'
      : 'Alexander Fedotov - Software Developer Personal Website';

    let metaLanguage = document.querySelector('meta[http-equiv="content-language"]');
    if (!metaLanguage) {
      metaLanguage = document.createElement('meta');
      metaLanguage.httpEquiv = 'content-language';
      document.head.appendChild(metaLanguage);
    }
    metaLanguage.content = language;

    const addOrUpdateHreflangTag = (lang, url) => {
      let hreflangTag = document.querySelector(`link[hreflang="${lang}"]`);
      if (!hreflangTag) {
        hreflangTag = document.createElement('link');
        hreflangTag.rel = 'alternate';
        hreflangTag.hreflang = lang;
        document.head.appendChild(hreflangTag);
      }
      hreflangTag.href = url;
    };

    const currentUrl = new URL(window.location);

    const enUrl = new URL(currentUrl);
    enUrl.searchParams.set('lang', 'en');
    addOrUpdateHreflangTag('en', enUrl.href);

    const ruUrl = new URL(currentUrl);
    ruUrl.searchParams.set('lang', 'ru');
    addOrUpdateHreflangTag('ru', ruUrl.href);

    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = currentUrl.href;
  }, [language]);

  const toggleLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};